module.exports = __webpack_public_path__ + "img/map_Z3.6.B.04.52206864.svg";